import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Engineering module landing page.
 *
 * Owner (2026-10-05): the department pages show MODULES, one card per module, the same
 * cards as General SS White (DeptLandingSections); a card shows only when the person may
 * open it. The Reports & KPI card opens the KPI hub on this department's tab.
 * The route is gated by dept.engineering in allRoutes.js.
 */
const MODULES = ["dms", "tasks", "di", "app-mafia", "app-perflexion", "cr", "project", "epo", "app-tooltracker", "kpi"];

const Engineering = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-pencil-ruler-2-line"
                        eyebrow="Design"
                        title="Engineering"
                        subtitle="Drawings, BOMs, and design workflow"
                        tone="teal"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Engineering" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="engineering" title="Engineering modules" icon="ri-pencil-ruler-2-line" />

                    <ComingSoonCard
                        compact
                        icon="ri-pencil-ruler-2-line"
                        title="More for Engineering later"
                        message="Ideas for later: a drawing browser by part number, BOM lookup and a drawing approval workflow. The modules above are live today."
                        tone="success"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Engineering;
